import React from "react";
import { getRoleLevel } from "../candidateProfilesFormConstants";
import { openModal } from "../../../app/common/modals/modalReducer";
import { STANDARD_MODAL } from "../../../app/common/modals/ModalManager";
import { useDispatch, useSelector } from "react-redux";
import CandidateProfile from "./CandidateProfile";
import { incrementValueInDocument } from "../../../app/firestore/firestoreService";
import {
  FIRESTORE_CANDIDATE_PROFILES_METRICS_COLLECTION,
  FIRESTORE_DOCUMENT_FIELDS,
} from "../../../app/firestore/firestoreConstants";

export default function ProfileSuggestionCard({ profile, style = {} }) {
  const dispatch = useDispatch();

  const { responsive } = useSelector((state) => state.app);
  const { currentUserAccount } = useSelector((state) => state.account);

  return (
    <div
      className="saved-job-item clickable hoverable"
      key={profile.objectId}
      onClick={async () => {
        if (!currentUserAccount.isAdmin) {
          await incrementValueInDocument({
            dbCollection: FIRESTORE_CANDIDATE_PROFILES_METRICS_COLLECTION,
            id: profile.ref,
            key: FIRESTORE_DOCUMENT_FIELDS.candidateProfileMetrics.views,
          });
        }
        dispatch(
          openModal({
            modalType: STANDARD_MODAL,
            component: (
              <CandidateProfile
                candidateProfile={profile}
                padding={responsive.isMobile ? 0 : "12px 18px 5px"}
                isEmployer={true}
              />
            ),
          })
        );
      }}
      style={{ padding: 10, ...style }}
    >
      <div style={{ minHeight: 70 }}>
        {currentUserAccount.isAdmin && (
          <div style={{ marginBottom: 8 }} className="map-marker-bold-text">
            {profile.objectID || profile.id} - {profile._score}
          </div>
        )}
        <div style={{ marginBottom: 8 }} className="map-marker-bold-text">
          {profile.name}{" "}
          {profile.currentJobTitle && "- " + profile.currentJobTitle}
        </div>
        <div className="statement">
          <span>Experience: </span>
          <span>
            {profile.roleLevel.map((level) => getRoleLevel(level)).join(", ")}
          </span>
        </div>
        <div
          className={"body-blue-text tag-colour"}
          style={{ marginTop: 10, fontSize: 14 }}
        >
          {profile.isOpenToWork && <span>Actively seeking jobs </span>}
          {profile.isOpenToWork && profile.isAvailableForInterviews && (
            <span> | </span>
          )}
          {profile.isAvailableForInterviews && (
            <span>Available for interview</span>
          )}
        </div>
      </div>
    </div>
  );
}
